export default "__VITE_ASSET__DpbbE4Ec__"